import send from '../../utils/fetch'
import path from '../../../API_URLS.json'
import {getLanguages} from '../../utils/utils'

const state = {}

const actions = {
    async getAdvertiserStatisticById({commit}, params) {
        try {
            const response = await send(path.statistic.adv, 'GET', {params})
            return response.data.result
        } catch (e) {
            return Promise.reject(e)
        }
    },

    // async getLanguagesByOfferId({commit}, params) {
    //     try {
    //         const response = await send()
    //     } catch (e) {
    //         return  Promise.reject(e)
    //     }
    // }
}

const mutations = {}

const getters = {}

export default {
    state,
    actions,
    mutations,
    getters
}
